import { createContext, useContext } from 'react'

import { BranchInfo, UserRole, UserWithBranches } from '../api/user/types'

export type UserContextType = {
  user: UserWithBranches | null
  isAdmin: boolean | null
  branchInfo: BranchInfo | null
  selectBranch: (branchInfo: BranchInfo) => void
  role: UserRole | null
  branchesLoading: boolean
}

export const UserContext = createContext<UserContextType>({
  user: null,
  isAdmin: null,
  branchInfo: null,
  selectBranch: () => {},
  role: null,
  branchesLoading: false,
})

export const useUser = () => {
  return useContext(UserContext)
}
